import { makeStyles } from '@material-ui/core';

import PINPEO from 'theme/palette';
import { NAV_WIDTH, NAV_WIDTH_COLLAPSED } from './NavBar/styles';

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    transition: 'padding-left .18s ease',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: NAV_WIDTH,
    },
  },
  wrapperCollapsed: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    transition: 'padding-left .18s ease',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: NAV_WIDTH_COLLAPSED,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    // Espacio para el botón flotante de menú en móvil
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(6),
    },
  },
  mobileMenuButton: {
    position: 'fixed',
    top: theme.spacing(1.5),
    left: theme.spacing(1.5),
    zIndex: theme.zIndex.drawer - 1,
    backgroundColor: theme.palette.background.paper,
    color: PINPEO.textSecondary,
    border: `1px solid ${PINPEO.borderStrong}`,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: PINPEO.rowHover,
    },
  },
}));
